import {Injectable} from "@angular/core";
 
import {HttpClient} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, tap} from "rxjs/operators";


@Injectable({providedIn: 'root'})
export class AnalyticService {

 
  constructor(private http: HttpClient){
     
  }

    getExpenses():Observable<any>{
    return this.http.get<any>(`/api/analytic/expenses`)
  } 

 
  getOverview():Observable<any>{
    return this.http.get<any>(`/api/analytic`)
  } 


  getIncomeOverview():Observable<any>{
    return this.http.get<any>(`/api/analytic/income`)
  } 

  getIncomeInner(id:string):Observable<any>{
    return this.http.get<any>(`/api/analytic/income/${id}`)
  } 

	 getStat(stream_id):Observable<any>{
	    return this.http.get<any>(`/api/analytic/${stream_id}`)
	  } 
    clearStat(stream_id):Observable<any>{
	    return this.http.get<any>(`/api/analytic/clear-stat/${stream_id}`)
	  } 
	 getPublihsStat(id):Observable<any>{
	    return this.http.get<any>(`/api/analytic/get-publish/${id}`)
	  } 
	 
 	getKeys(stream_id):Observable<any>{
	    return this.http.get<any>(`/api/analytic/get-keys/${stream_id}`)
	  } 
 
 	getPubKeys(id):Observable<any>{
	    return this.http.get<any>(`/api/analytic/get-pub-keys/${id}`)
	  } 	
	

	  updatePublish(id:string, publish:boolean): Observable<any>{
	    return this.http.post<any>(`/api/analytic/publish/${id}`, {publish: publish})
	  }
 
}
